import React from "react";
import EyeNoData from "../../../../components/Nav & Header/Eye";

function NoComments() {
  return (
    <div>
      <div className="mt-[50px] lg:mt-[100px] md:gap-y-[0px] lg:gap-y-[40px] flex flex-col items-center justify-center w-full">
        <div className="nodatazoom">
          <EyeNoData />
        </div>
        <div className="space-y-6 max-w-[350px] text-center text-tertiary">
          <p className="text-[14px] sm:text-[16px] capitalize font-SoraL">
            No comments available, be the first one to comment!
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoComments;
